import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {Http, Response, Headers, RequestOptions} from "@angular/http";
import {UserStorageService} from "../authentication/user-storage.service";

@Injectable()
export class UploadService {

  constructor(private http: Http, private userStorage: UserStorageService) { }

  upload(url: string, fileName: string, file: File): Observable<Response> {
    let input = new FormData();
    input.append(fileName, file);
    return this.http.post(url, input, this.getOptions());
  }

  private getOptions() {
    if (this.userStorage.oauthToken != null) {
      let headers = new Headers({
        "Authorization": "Bearer " + this.userStorage.oauthToken.access_token,
      });
      return new RequestOptions({headers: headers});
    }
    return null;
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/http/upload.service.ts